module.exports = __webpack_public_path__ + "img/search-engines-amico.0186dd4a.svg";